import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogData } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog-data';
import { SkipTestModalComponent } from '../skip-test-modal/skip-test-modal.component';
import { Router } from '@angular/router';
import { SitefinityContentService } from 'src/app/core/services/settings/sitefinity-content.service';
import { ADPResourceService } from 'digital-core';
import { CellularEnabledInfoModalComponent } from 'src/app/modules/device-diagnostics/components/cellular-enabled-info-modal/cellular-enabled-info-modal.component';

@Component({
  selector: 'pgh-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
})
export class LandingPageComponent implements OnInit {
  @Output() nextEvent = new EventEmitter();
  @Input() isOnboardingFlow?:boolean = false;

  public welcomeImageUrl: string='';
  public welcomeImageAlt: string='';
  public welcomeMobileImageUrl: string='';
  public welcomeMobileImageAlt: string='';

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private resourceService: ADPResourceService
  ) { }

  ngOnInit(): void {

    this.welcomeImageUrl = this.resourceService.getPortalImage('Global_Onboarding_Welcome_Image').ImageURL;
    this.welcomeImageAlt = this.resourceService.getPortalImage('Global_Onboarding_Welcome_Image').Caption;
    this.welcomeMobileImageUrl = this.resourceService.getPortalImage('Global_Onboarding_Welcome_Mobile_Image').ImageURL;
    this.welcomeMobileImageAlt = this.resourceService.getPortalImage('Global_Onboarding_Welcome_Mobile_Image').Caption;

  }

  next() : void {
    this.nextEvent.emit('next');
  }

  public handleCellularEnabledInfo(){

    const dialogConfig = new MatDialogConfig();

    const dialogRef = this.dialog.open(CellularEnabledInfoModalComponent, dialogConfig);
  }

  skipTest(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: (this.resourceService.getPortalLabel("Global_Onboarding_SkipTest_Title").Value),
      message1: (this.resourceService.getPortalLabel("Global_Onboarding_SkipTest_Message1").Value),
      message2: (this.resourceService.getPortalLabel("Global_Onboarding_SkipTest_Message2").Value),
      message3: (this.resourceService.getPortalLabel("Global_Onboarding_SkipTest_Message3").Value),
      cancelButtonText: (this.resourceService.getPortalLabel("Global_Onboarding_SkipTest_Button_Cancel").Value),
      confirmButtonText: (this.resourceService.getPortalLabel("Global_Onboarding_SkipTest_Button_Confirm").Value),
    };

    const dialogRef = this.dialog.open(SkipTestModalComponent, dialogConfig);

    /*const dialogData: ConfirmationDialogData = {
      // TODO: hook up to widget content once it is available.
      title: ('Are you sure you want to skip test?'),
      message: ('The plan does not cover untested phones and you won’t be able to File a claim until they have been tested.<br/> You can test your and your household members\' phones later in your PGH account.').split("<br/>").join("\n"),
      cancelButtonText: ('Skip Test'),
      confirmButtonText: ('Keep Testing the Device'),
    };*/

    /*const confirmationDialog = this.dialog.open<ConfirmationDialogComponent, ConfirmationDialogData, boolean>(ConfirmationDialogComponent, {
      data: dialogData,
    });*/

    dialogRef.afterClosed().subscribe(res => {
      // received data from dialog-component
      if (res.data.toString() !== 'success') {
        sessionStorage.setItem('redirect-from', 'po');
        this.router.navigate(['/dashboard']);
      }
      else{
        dialogRef.close();
      }
    });
  }
}
